export const getBanners = (apiInstance) => {
  let requestParameters = {
    method: 'GET',
    mode: 'cors',
    headers: apiInstance.headers
  }

  return fetch(`${apiInstance.apiURL}/Banners`, requestParameters)
}
